module.exports = __webpack_public_path__ + "img/益视说明书_10.213f8091.png";